var _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgGroupCirclesLeft = function SvgGroupCirclesLeft(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    iewBox: "0 0 134 188",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.8,
    r: 46.5,
    transform: "matrix(-1 0 0 1 87.5 93.5)",
    fill: "#8ED6C9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.8,
    cx: 20.5,
    cy: 167.5,
    r: 20.5,
    fill: "#FFD67C"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.8,
    cx: 55,
    cy: 14,
    r: 14,
    fill: "#82C6FF"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGroupCirclesLeft);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBpZXdCb3g9IjAgMCAxMzQgMTg4IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxjaXJjbGUgb3BhY2l0eT0iLjgiIHI9IjQ2LjUiIHRyYW5zZm9ybT0ibWF0cml4KC0xIDAgMCAxIDg3LjUgOTMuNSkiIGZpbGw9IiM4RUQ2QzkiLz48Y2lyY2xlIG9wYWNpdHk9Ii44IiBjeD0iMjAuNSIgY3k9IjE2Ny41IiByPSIyMC41IiBmaWxsPSIjRkZENjdDIi8+PGNpcmNsZSBvcGFjaXR5PSIuOCIgY3g9IjU1IiBjeT0iMTQiIHI9IjE0IiBmaWxsPSIjODJDNkZGIi8+PC9zdmc+";